import { type Feature } from "@/api-v3";
import { useBootstrap } from "@/features/bootstrap";

/**
 * Whether a backend feature flag is on for the tenant, read from App Bootstrap.
 *
 * GET /bootstrap lists every flag row the tenant has, switched off ones too, so
 * only a row with `is_enabled` counts. While bootstrap is loading, after it
 * fails, or when the tenant has no row, the feature reads as off.
 */
export const useFeatureFlag = (feature: Feature): boolean => {
  const { data } = useBootstrap();

  return (
    data?.feature_flags.some(
      (flag) => flag.feature === feature && flag.is_enabled
    ) ?? false
  );
};
